import { useEffect, useState } from "react";
import { useCart } from "../context/CartContext";
import "../styles/Notification.css";

export default function Notification() {
  const { notification } = useCart();
  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (notification) {
      setIsVisible(true);
      setIsExiting(false);
      
      // Start exit animation after 2.2 seconds
      const exitTimer = setTimeout(() => {
        setIsExiting(true);
      }, 2200);
      
      // Remove notification after animation completes
      const removeTimer = setTimeout(() => {
        setIsVisible(false);
        setIsExiting(false);
      }, 2500);

      return () => {
        clearTimeout(exitTimer);
        clearTimeout(removeTimer);
      };
    }
  }, [notification]);

  if (!isVisible || !notification) return null;

  return (
    <div className={`notification-wrapper ${isExiting ? "exiting" : ""}`}>
      <div className="notification">
        <div className="notification-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
            <path d="M8 12L11 15L16 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
        <div className="notification-content">
          <span className="notification-product">{notification.productName}</span>
          <span className="notification-message">{notification.message}</span>
        </div>
        <button 
          className="notification-close"
          onClick={() => setIsExiting(true)}
        >
          ✕
        </button>
      </div>
    </div>
  );
}